import React, { useState, useEffect, useContext, Component } from 'react';
import { Link, useNavigate } from 'react-router-dom'

import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/store';
import axios from 'axios';
import axiosInstance, { weburl } from '../../../axiosInstance';
import Header from '../../components/Header';
import Footer from '../../components/Footer';


import { Helmet } from 'react-helmet';
import getCookie from '../../../helper/getCookie';
import LoadingScreen from '../../components/LoadingScreen';
import getDecryptData from '../../../helper/getDecryptData';
import { useBlogContext } from '../../../fetchdata/BlogContext';

const AccountAllOrder = () => {
  const { Headers, isHeader } = useBlogContext();

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setlimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchData = async () => {
    const decryptdatajson = await getDecryptData();
    const userId = decryptdatajson?._id;
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/all-orders?page=${currentPage}&limit=${limit}&search=${searchTerm}&userId=${userId}&type=3`);
      setData(response.data.Order || []);
      setCurrentPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
      console.log(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, limit]);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };




  const inputRef = React.createRef();

  const handleSearchInputChange = (e) => {
    setCurrentPage(1);
    setTotalPages(1)
    setSearchTerm(e.target.value);


  };

  const handleSearch = () => {
    fetchData(currentPage);

  };


  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const options = {
      month: 'long', // Use 'long' to display the full month name
      day: 'numeric',
      year: 'numeric',
      // hour: 'numeric',
      // minute: 'numeric',
      // second: 'numeric',
      // hour12: true
    };
    return date.toLocaleString('en-US', options);
  };


  
    const handleStatusChange = (ratingId) => async (event) => {
      const newStatus = event.target.value;
      setLoading(true);
  
      try {
        await axiosInstance.put(`/admin/update-order/${ratingId}`, { status: newStatus });
        setLoading(false);
        fetchData(currentPage);
        toast.success("Status Updated success!");
      } catch (error) {
        console.error('Error updating rating status:', error);
        setLoading(false);
      }
  
    };

    const getRemainingMins = (row) => {
  // Use API field if available
  if (row?.queueRemainingMins != null) return row.queueRemainingMins;

  // Example (if you have appointmentStartTime like "09:30")
  // return null if not possible
  return null;
};


  return (
    <>

      <Header page={'All Appointment'} link="/account" />

      <Helmet>
        <title> Account Appointment | {window.location.hostname}</title>

      </Helmet>



      <div className="user-dasboard whitesmoke"  style={{minHeight:'80vh'}} >

        <div className="container pt-4">
          <div className="row pb-4">

            <AccountSidebar />

            <div className="col-lg-9 my-lg-0 my-1">
              <div id="main-content" className="bg-light border" >


                <h4 className="mb-2">All Appointment</h4>



                {loading ? <LoadingScreen />
                  :
                  <div className="card bg-transparent border-0 mb-4" >


                    <div className="row">


                      <div className="datatable-top d-flex align-items-center justify-content-between w-100 border-bottom pb-3 gap-2">
                     
                     <div className="d-flex bg-white border rounded-pill px-2 py-1 flex-fill ">
                  <i class="ri-search-line fs-4 px-2 py-1"/>
                  <input className="form-control border-0 shadow-none p-0 ps-1" placeholder='Search Appointment' />
                      </div>


 <div class="dropdown h-100" style={{aspectRatio:'1/1'}}  >
                                  <button class="btn border rounded-circle px-1 bg-white w-100" style={{aspectRatio:'1/1'}} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i class="ri-equalizer-2-line fs-5"></i>
                                  </button>
                                  <div class="dropdown-menu p-2 whitespace-nowrap">
                                    <label className='d-flex align-items-center gap-2'>
                            <select className="form-control w-auto" value={limit} onChange={(e) => {
                              setlimit(parseInt(e.target.value, 10));
                              setCurrentPage(1); // Reset current page to 1 when the limit changes
                            }} >
                              <option value={5}>5 per page</option>
                              <option value={10} >
                                10 per page
                              </option>
                              <option value={15}>15 per page</option>
                              <option value={20}>20 per page</option>
                              <option value={25}>25 per page</option>
                            </select>{" "}

                            
                          </label>
                                  </div>
                                </div> 


                        

                      </div>


 <div className="orders-compact mt-3">
  {data.map((row, idx) => {
    const statusInfo =
      row.status === 0 ? { text: "Processing", cls: "bg-secondary text-white" } :
      row.status === 1 ? { text: "Completed", cls: "bg-success text-white" } :
      row.status === 2 ? { text: "Cancelled", cls: "bg-danger text-white" } :
      row.status === 3 ? { text: "Reschedule", cls: "bg-warning text-dark" } :
      { text: "Unknown", cls: "bg-danger text-white" };

    const typeText =
      row.type === 1 ? "Order" :
      row.type === 2 ? "Rental" :
      row.type === 3 ? "Appointment" :
      row.type === 4 ? "Nurse" :
      "Unknown";

    // ---- helpers (inside map scope) ----
    const formatDate = (d) => {
      if (!d) return "-";
      try {
        return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
      } catch {
        return "-";
      }
    };

    const formatTimeRange = (p) => {
      // prefer explicit time range; fallback to p.time; then "Any Time"
      const st = p?.startTime || "";
      const et = p?.endTime || "";
      if (st && et) return `${st} - ${et}`;
      if (p?.time) return p.time;
      return "Any Time";
    };

    const getBookingStatusText = (p) =>
      p?.status === 0 ? "Pending" :
      p?.status === 1 ? "Completed" :
      p?.status === 2 ? "Cancelled" :
      p?.status === 3 ? "Reschedule" : "NA";

    const getBookingStatusClass = (p) =>
      p?.status === 1 ? "bg-success text-white" :
      p?.status === 2 ? "bg-danger text-white" :
      p?.status === 3 ? "bg-warning text-dark" :
      "bg-secondary text-white";

    const getQueueSubText = (p) => {
      const st = (p?.subType || "").toLowerCase();
      if (st === "hold") return "On Hold";
      if (st === "priority") return "Priority";
      if (st === "remove") return "Removed";
      if (st === "unhold" || st === "unpriority" || !st) return "In Queue";
      return st;
    };

    const getQueueSubClass = (p) => {
      const st = (p?.subType || "").toLowerCase();
      if (st === "hold") return "bg-warning text-dark";
      if (st === "priority") return "bg-success text-white";
      if (st === "remove") return "bg-danger text-white";
      return "bg-secondary text-white";
    };

    return (
      <div key={row?._id || idx} className="mb-3 rounded py-3">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h5 className="mb-0">
            <span className="d-inline-block w-auto border-bottom border-3 border-info pb-2">
              Order Id : # {row.orderId ?? "--"}
            </span>
          </h5>

          <div className="d-flex col-4 gap-2 justify-content-end align-items-center">
            <span className={`apx-status ${statusInfo.cls}`}>{statusInfo.text}</span>

            <Link
              to={`/account/booking/${row._id}`}
              className="apx-detail-btn bg-dark text-white"
              title="Appointment Details"
            >
              <span className="d-inline">Details</span>
            </Link>

            {/* User */}
            <div className="dropdown">
              <button
                className="apx-icon-btn"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                title="User"
              >
                <i className="ri-user-3-line"></i>
              </button>
              <ul className="dropdown-menu p-2">
                <li className="text-nowrap"><b>User Details</b></li>
                <li className="text-nowrap">Name: {row?.UserDetails?.[0]?.name || "-"}</li>
                <li className="text-nowrap">Phone: {row?.UserDetails?.[0]?.phone || "-"}</li>
                <li className="text-nowrap">Email: {row?.UserDetails?.[0]?.email || "-"}</li>
              </ul>
            </div>

            {/* Action */}
            <div className="dropdown">
              <button
                className="apx-icon-btn"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                title="Action"
              >
                <i className="ri-more-2-fill"></i>
              </button>

              <ul className="dropdown-menu p-2">
                <li className="text-nowrap mb-1"><b>Invoice</b></li>
                <li className="mb-3">
                  <a
                    href={`${weburl}user-invoice/${row._id}`}
                    className="btn btn-sm btn-primary w-100"
                  >
                    View Invoice
                  </a>
                </li>

                <li className="text-nowrap mb-1"><b>Update Status</b></li>
                <li>
                  <select
                    disabled={row.status === 5}
                    className="form-control form-control-sm"
                    value={row.status}
                    name="status"
                    onChange={handleStatusChange(row._id)}
                  >
                    <option value={row.status}>Select Status</option>
                    <option value="5">Cancel {typeText}</option>
                  </select>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <ul className="list-group">
          {(row?.addProduct || []).map((product, index) => {
            const serviceName = product?.title || "-";
            const doctorName = product?.employee?.label ?? "NA";
            const dateText = product?.date ? formatDate(product.date) : "-";
            const timeText = formatTimeRange(product);

            return (
              <li className="list-group-item" key={product?._id || index}>
                <div className="d-flex align-items-center gap-3">
                  <div style={{ width: 90 }}>
                    <img
                      src={
                        product?.employee?.data?.profile
                          ? weburl + product?.employee?.data?.profile
                          : "/assets/img/profile.webp"
                      }
                        onError={(e) => {
    e.target.onerror = null; // prevents infinite loop
    e.target.src = "/assets/img/profile.webp";
  }}
                      style={{ width: 80, height: 80, maxWidth: 80,maxHeight: 80, objectFit: "cover" }}
                      className="border border-3 rounded-circle"
                      alt={doctorName}
                    />
                  </div>

                  <div className="col text-start">
                    {/* Doctor + booking status (per product) */}
                    <div className="d-flex flex-wrap align-items-center gap-2">
                      <h5 className="mb-0">{doctorName}</h5>
                      <span className={`apx-status ${getBookingStatusClass(product)}`}>
                        {getBookingStatusText(product)}
                      </span>
                      <span className={`apx-status ${getQueueSubClass(product)}`}>
                        {getQueueSubText(product)}
                      </span>
                    </div>

                    {/* Service name */}
                    <div className="small text-muted mt-1">
                      <b>Service:</b> {serviceName}
                    </div>

                    {/* Date / Time */}
                    <div className="small text-muted mt-1 d-flex flex-wrap gap-3">
                      <span><b>Date:</b> {dateText}</span>
                      <span>
                        <b>Time:</b>{" "}
                        {timeText === "Any Time" ? (
                          <span className="apx-status bg-success text-white small d-inline-block">
                            Any Time
                          </span>
                        ) : (
                          timeText
                        )}
                      </span>

                      {/* Optional: Position/ETA if you have it */}
                      {typeof product?.position === "number" && product.position > 0 && (
                        <span>
                          <b>Queue:</b> #{product.position}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Right side badges */}
                  <div className="col-3 text-end">
                    {product?.subType === "hold" && (
                      <span className="apx-status bg-warning text-dark">On Hold</span>
                    )}
                    {product?.subType !== "hold" && (
                      <span className="apx-status bg-secondary text-white">In Queue</span>
                    )}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  })}
</div>



 
 {data === 'test' && 
 
 <div className="orders-compact mt-3">
  {data.map((row, idx) => {
    const statusInfo =
      row.status === 0 ? { text: "Processing", cls: "bg-secondary text-white" } :
      row.status === 1 ? { text: "Completed", cls: "bg-success text-white" } :
      row.status === 2 ? { text: "Cancelled", cls: "bg-danger text-white" } :
      row.status === 3 ? { text: "Reschedule", cls: "bg-warning" } : 
      { text: "Unknown", cls: "bg-danger" };

    const typeText =
      row.type === 1 ? "Order" :
      row.type === 2 ? "Rental" :
      row.type === 3 ? "Appointment" :
      row.type === 4 ? "Nurse" :
      "Unknown";

    // Doctor info (fallbacks)
    const doctorName = row?.employeeId?.username || "Doctor";
    const doctorRole = row?.employeeId?.role || "Primary care doctor";
    const doctorImg =
     ( weburl + row?.employeeId?.profile ) ||
      "/assets/img/profile.webp";

    // Visit type (you can map using your real field if exists)
    const visitType =
      row?.visitType || (row.type === 3 ? "Video visit" : typeText);

    return (
      <>
<div className='mb-3 rounded py-3'>
<div className="d-flex align-items-center justify-content-between mb-3">
  <h5 className='mb-0'> <span className='d-inline-block w-auto border-bottom border-3 border-info pb-2'> Order Id : # {row.orderId ?? '--'}</span></h5>
  <div className='d-flex col-4 gap-2 justify-content-end align-items-center '>
          <span className={`apx-status ${statusInfo.cls}`}>{statusInfo.text}</span>
  <Link to={`/account/booking/${row._id}`}
      className="apx-detail-btn bg-dark text-white" 
      title="Appointment Details"
    >
       
      <span className="d-inline">Details</span>
    </Link>

            {/* User */}
            <div className="dropdown">
              <button className="apx-icon-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false" title="User">
                <i className="ri-user-3-line"></i>
              </button>
              <ul className="dropdown-menu p-2">
                <li className="text-nowrap"><b>User Details</b></li>
                <li className="text-nowrap">Name: {row.UserDetails[0]?.name}</li>
                <li className="text-nowrap">Phone: {row.UserDetails[0]?.phone}</li>
                <li className="text-nowrap">Email: {row.UserDetails[0]?.email}</li>
              </ul>
            </div>

        
 

            {/* Action */}
            <div className="dropdown">
              <button className="apx-icon-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false" title="Action">
                <i className="ri-more-2-fill"></i>
              </button>
              <ul className="dropdown-menu p-2">
                  <li className="text-nowrap mb-1"><b>Invoice</b></li>
                  <li className="mb-3"> <a  href={`${weburl}user-invoice/${row._id}`} className="btn btn-sm btn-primary w-100" > View Invoice</a> </li>

                <li className="text-nowrap mb-1"><b>Update Status</b></li>
                <li>
                  <select
                    disabled={row.status === 5}
                    className="form-control form-control-sm"
                    value={row.status}
                    name="status"
                    onChange={handleStatusChange(row._id)}
                  >
                    <option value={row.status}>Select Status</option>
                    <option value="5">Cancel {typeText}</option>
                  </select>
                </li>
              </ul>
            </div>



  </div>
  </div>

  <ul className="list-group">
    {row.addProduct.map((product, index) => (
  <li className="list-group-item" key={index}>
    <div className="d-flex align-items-center gap-2">
      <div style={{width:100}}>
      <img   
      src={
    product?.employee?.data?.profile
      ? weburl + product?.employee?.data?.profile
      : "/assets/img/profile.webp"
  }
 style={{width:100,aspectRatio:'1/1',objectFit:'cover'}} 
 className='border border-3 rounded-circle'/>
      </div>
      <div className='col text-start'>
      <h5 className='mb-0'> {product?.employee?.label ?? 'NA'} </h5>
      <p className='small'> {product?.time ? product?.time : <span className='apx-status bg-success text-white small d-inline-block'>Any Time </span>} </p>
      </div>
       <div className='col-2 text-end'>
         <span class="apx-status bg-secondary text-white">In Quee</span>
      </div>
    </div>
  </li>
    ))} 

  
</ul>



</div>

 
            </>
    );
  })}
</div>
}


                      <div className='container mt-4'>
                        <div className='d-flex bg-light border  align-center p-2 mx-auto overflow-hidden justify-content-between' style={{ maxWidth: '500px', borderRadius: '40px' }}>
                          <button href="/hospital/67973150a76a66c3198c5060" onClick={handlePreviousPage} disabled={loading || currentPage === 1} className="btn btn-white btn-shadow d-block border " style={{ borderRadius: '40px' }} >Previous</button>
                          <div className='col align-items-center d-flex justify-content-center'>
                            <span>   Showing  {currentPage} of {totalPages} </span>
                          </div>
                          <button className="btn btn-white btn-shadow d-block border" style={{ borderRadius: '40px' }} onClick={handleNextPage} disabled={loading || currentPage === totalPages} >Next</button>

                        </div>
                      </div>


                    </div>
                  </div>
                }

              </div>
            </div>
          </div>
        </div>

      </div>



      <Footer />


    </>
  )
}

export default AccountAllOrder